<template>
  <div>
    <booking-policy-form page="setting" />
  </div>
</template>

<script>
import BookingPolicyForm from "./BookingPolicyForm";

export default {
	name: "Policy",
	components: { BookingPolicyForm },
};
</script>

<style>
</style>
